import './styles.scss'

const BaseStep = ({ children }) => {
  return <div className="base-step">{children}</div>
}

export default BaseStep
